export const translation = {
  // SEO & Meta
  siteName: 'CSSBuy Spreadsheet',
  siteDescription: 'Encontre o CSSBuy Spreadsheet, guias de compra, informações sobre QC, armazém, frete, cupons e avaliações.',
  title: 'CSSBuy Spreadsheet 2026: Guias, Ofertas, QC e Frete',
  metaDescription: 'Encontre o CSSBuy Spreadsheet, guias de compra, informações sobre QC, armazém, frete, cupons e avaliações. Compare opções e encontre recursos atualizados para suas compras.',
  
  // Navigation
  navHome: 'Início',
  navGuide: 'Guia',
  navReview: 'Review',
  navShipping: 'Frete',
  navCoupon: 'Cupom',
  navWarehouse: 'Armazém',
  navSafety: 'Segurança',
  navFAQ: 'FAQ',
  navAbout: 'Sobre',
  navContact: 'Contato',
  navArticle: 'Artigo',
  navShoppingGuide: 'Guia de Compras',
  navGuides: 'Guias',
  
  // Language
  language: 'Idioma',
  pt: 'Português',
  de: 'Deutsch',
  en: 'English',
  
  // Categories
  categoriesTitle: 'Categorias',
  categoriesDropdown: 'Selecionar Categoria',
  shoes: 'Shoes',
  hoodiesSweaters: 'Hoodies/Sweaters',
  tShirts: 'T-Shirts',
  jackets: 'Jackets',
  pantsShorts: 'Pants/Shorts',
  headwear: 'Headwear',
  sets: 'Sets',
  underwear: 'Underwear/Underpants',
  jersey: 'Jersey',
  accessories: 'Accessories',
  bags: 'Bags',
  belts: 'Belts',
  perfumes: 'Perfumes',
  otherStuff: 'Other Stuff',
  
  // Hero
  heroH1: 'CSSBuy Spreadsheet: Encontre Produtos, Guias e Informações em Um Só Lugar',
  heroSubtitle: 'Explore o CSSBuy Spreadsheet, descubra produtos, compare informações e aprenda como usar o CSSBuy com mais segurança e eficiência.',
  heroCtaPrimary: 'Explorar CSSBuy Spreadsheet',
  heroCtaSecondary: 'Ver Guia Completo',
  heroTrust: 'Informação independente • Guias atualizados • Recursos organizados',
  heroDisclaimer: 'Este site é um recurso independente e não representa oficialmente o CSSBuy.',
  
  // What is
  whatIsTitle: 'O que é o CSSBuy Spreadsheet?',
  whatIsH2: 'CSSBuy Spreadsheet: Tudo o que você precisa para pesquisar melhor',
  whatIsDesc: 'O CSSBuy Spreadsheet é uma forma prática de organizar e encontrar informações relacionadas a produtos, categorias, links e recursos utilizados por compradores. Use recursos organizados para comparar opções e pesquisar com mais eficiência.',
  whatIsWarning: 'Antes de comprar, sempre confirme o link atual, vendedor, preço, disponibilidade, QC e condições de envio.',
  whatIsCta: 'Explorar o CSSBuy Spreadsheet →',
  
  // Why Use
  whyUseTitle: 'Por que usar o CSSBuy Spreadsheet?',
  whyUseH2: 'Um lugar simples para pesquisar, comparar e aprender',
  whyFindTitle: 'Encontre rapidamente',
  whyFindDesc: 'Pesquise categorias e recursos relacionados ao CSSBuy Spreadsheet.',
  whyCompareTitle: 'Compare opções',
  whyCompareDesc: 'Compare produtos e informações em tabelas organizadas.',
  whyShippingTitle: 'Entenda o envio',
  whyShippingDesc: 'Aprenda sobre peso, frete e consolidação.',
  whyQCTitle: 'Confira o QC',
  whyQCDesc: 'Aprenda a analisar fotos de controle de qualidade.',
  whySafetyTitle: 'Compre com mais informação',
  whySafetyDesc: 'Consulte recursos de segurança antes de comprar.',
  
  // Commercial Cards
  commercialTitle: 'Recursos CSSBuy',
  reviewTitle: 'CSSBuy Review',
  reviewDesc: 'Análise independente sobre recursos, experiência, vantagens e pontos de atenção.',
  reviewCta: 'Ler CSSBuy Review →',
  shippingCostTitle: 'CSSBuy Shipping Cost',
  shippingCostDesc: 'Entenda os principais fatores que influenciam o custo de envio.',
  shippingCostCta: 'Ver Shipping Cost Guide →',
  couponTitle: 'CSSBuy Coupon',
  couponDesc: 'Informações sobre cupons e promoções atuais.',
  couponCta: 'Ver Coupon Guide →',
  discountCodeTitle: 'CSSBuy Discount Code',
  discountCodeDesc: 'Como verificar códigos de desconto e promoções.',
  discountCodeCta: 'Ver Discount Code Guide →',
  warehouseTitle: 'CSSBuy Warehouse',
  warehouseDesc: 'Informações sobre armazenamento, QC e preparação.',
  warehouseCta: 'Ver Warehouse Guide →',
  legitTitle: 'Is CSSBuy Legit?',
  legitDesc: 'Informações de segurança e verificação.',
  legitCta: 'Ler CSSBuy Legit Guide →',
  
  // Comparison
  comparisonTitle: 'Compare antes de comprar',
  comparisonH2: 'CSSBuy Spreadsheet: Compare antes de comprar',
  comparisonFeature: 'Recurso',
  comparisonCssbuy: 'CSSBuy',
  comparisonAlternative: 'Alternativa',
  comparisonProductResearch: 'Product Research',
  comparisonSpreadsheetResources: 'Spreadsheet Resources',
  comparisonQCInfo: 'QC Information',
  comparisonShippingGuide: 'Shipping Guide',
  comparisonWarehouseGuide: 'Warehouse Guide',
  comparisonSafetyGuide: 'Safety Guide',
  comparisonYes: '✓',
  
  // FAQ
  faqTitle: 'FAQ',
  faqH2: 'CSSBuy Spreadsheet FAQ',
  faq1Q: 'What is CSSBuy Spreadsheet?',
  faq1A: 'CSSBuy Spreadsheet é uma ferramenta de organização de recursos para compradores pesquisarem produtos e categorias de forma estruturada.',
  faq2Q: 'How does CSSBuy Spreadsheet work?',
  faq2A: 'Organiza links, categorias e informações em um formato acessível para facilitar a pesquisa de produtos.',
  faq3Q: 'How do I use CSSBuy Spreadsheet?',
  faq3A: 'Navegue pelas categorias, confira os links e sempre verifique o vendedor e o QC antes de comprar.',
  faq4Q: 'Is CSSBuy legit?',
  faq4A: 'CSSBuy é um agente de compras conhecido. Sempre verifique links e vendedores antes de comprar.',
  faq5Q: 'Is CSSBuy safe?',
  faq5A: 'Siga as práticas de segurança: verifique domínios, links, QC e nunca compartilhe senhas.',
  faq6Q: 'How much does CSSBuy shipping cost?',
  faq6A: 'O custo depende do peso, dimensões, linha de envio e destino. Use guias para estimar.',
  faq7Q: 'Does CSSBuy have coupons?',
  faq7A: 'Cupons e códigos de desconto podem estar disponíveis. Verifique fontes oficiais e atualizadas.',
  faq8Q: 'What is the CSSBuy discount code?',
  faq8A: 'Códigos de desconto variam. Sempre verifique a validade e fonte confiável.',
  faq9Q: 'How does CSSBuy warehouse work?',
  faq9A: 'O armazém recebe, inspeciona e prepara pacotes para envio. Consulte guias para detalhes.',
  faq10Q: 'What is CSSBuy QC?',
  faq10A: 'QC (Quality Control) são fotos de inspeção do produto antes do envio.',
  
  // Final CTA
  finalCtaTitle: 'Pronto para explorar o CSSBuy Spreadsheet?',
  finalCtaDesc: 'Encontre guias, recursos, comparações e informações úteis para pesquisar melhor.',
  finalCtaPrimary: 'Explorar CSSBuy Spreadsheet →',
  finalCtaSecondary: 'Visitar o Guia Completo →',
  
  // Buttons
  cssbuySpreadsheet: 'CSSBuy Spreadsheet',
  buyItNow: 'Buy it now',
  exploreNow: 'Explorar Agora',
  readMore: 'Ler Mais',
  viewGuide: 'Ver Guia',
  
  // Footer
  footerDisclaimer: 'cssbuybr.surf is an independent informational resource. CSSBuy names, trademarks and third-party services belong to their respective owners.',
  footerPrivacy: 'Privacidade',
  footerTerms: 'Termos',
  footerDisclaimerLink: 'Aviso Legal',
  footerContact: 'Contato',
  
  // Article Page
  articleTitle: 'CSSBuy Spreadsheet: Guia Completo 2026',
  articleH1: 'CSSBuy Spreadsheet – Complete Guide',
  articleBackToHome: '← Voltar para Início',
  articleMeta: 'Publicado em 26 de agosto de 2026 • Atualizado em 26 de agosto de 2026',
  articleAuthor: 'Autor: CSSBuy Resource Team',
  
  // Article Sections
  articleToc: 'Conteúdo',
  articleWhatIs: 'O que é o CSSBuy Spreadsheet?',
  articleHowWorks: 'Como funciona o CSSBuy Spreadsheet?',
  articleFindProducts: 'Como encontrar produtos',
  articleReadSpreadsheet: 'Como ler uma planilha',
  articleCategories: 'Categorias de produtos',
  articleSellerInfo: 'Informações do vendedor',
  articleQC: 'QC (Quality Control)',
  articleWarehouse: 'Armazém',
  articleShipping: 'Envio',
  articleSafety: 'Segurança',
  articleMistakes: 'Erros comuns',
  articleComparison: 'Comparação',
  articleFAQ: 'FAQ',
  
  // Safety Page
  safetyH1: 'CSSBuy Safety Guide',
  safetyVerifyDomain: 'Verifique o domínio',
  safetyVerifyLinks: 'Verifique links de produtos',
  safetyCheckSeller: 'Verifique o vendedor',
  safetyReviewQC: 'Revise o QC',
  safetyConfirmPrice: 'Confirme o preço',
  safetyConfirmShipping: 'Confirme o frete',
  safetyNeverSharePassword: 'Nunca compartilhe senhas',
  safetyAvoidPayment: 'Evite solicitações de pagamento suspeitas',
  safetyVerifyCoupons: 'Verifique cupons',
  safetyCheckPolicies: 'Verifique as políticas atuais',
  safetyBewareFake: 'Cuidado com sites falsos',
  
  // Announcement
  announcement: 'Recurso independente • Não é o site oficial do CSSBuy',
  
  // Breadcrumb
  breadcrumbHome: 'Início',
  breadcrumbArticle: 'Artigo',
  
  // Schema / Meta
  metaKeywords: 'CSSBuy Spreadsheet, CSSBuy Review, CSSBuy Shipping, CSSBuy Coupon, CSSBuy Discount Code, CSSBuy Warehouse, CSSBuy Legit, CSSBuy QC',
  ogTitle: 'CSSBuy Spreadsheet 2026: Guias, Ofertas, QC e Frete',
  ogDescription: 'Encontre o CSSBuy Spreadsheet, guias de compra, informações sobre QC, armazém, frete, cupons e avaliações.',
  
  // Related Articles
  relatedArticles: 'Artigos Relacionados',
  relatedReview: 'CSSBuy Review 2026',
  relatedShipping: 'CSSBuy Shipping Cost Guide',
  relatedCoupon: 'CSSBuy Coupon Guide',
  relatedWarehouse: 'CSSBuy Warehouse Guide',
  relatedLegit: 'Is CSSBuy Legit?',
  relatedQC: 'CSSBuy QC Guide',
  
  // Internal Link Anchors
  linkSpreadsheet: 'CSSBuy Spreadsheet',
  linkSpreadsheetGuide: 'CSSBuy spreadsheet guide',
  linkSpreadsheetResources: 'spreadsheet resources',
  linkBuyingGuide: 'CSSBuy buying guide',
  linkQCGuide: 'CSSBuy QC guide',
  linkShippingGuide: 'CSSBuy shipping guide',
  linkSafetyGuide: 'CSSBuy safety guide',
  
  // Product category cards on homepage
  productCategoriesTitle: 'Categorias Populares',
  productCategoriesDesc: 'Explore as principais categorias do CSSBuy Spreadsheet',
  
  // Latest Guides
  latestGuidesTitle: 'Últimos Guias',
  latestGuidesDesc: 'Guias atualizados sobre CSSBuy',
  pillarSectionLabel: 'Guias Detalhados',
  pillarSectionTitle: 'Guias Principais do CSSBuy',
  pillarSectionDesc: 'Explore nossa coleção completa de guias detalhados do CSSBuy cobrindo cada etapa da sua jornada de compras.',
  
  // Trust Badges
  trustIndependent: 'Informação independente',
  trustUpdated: 'Guias atualizados',
  trustOrganized: 'Recursos organizados',

  // Product showcase
  allProducts: 'Todos os Produtos',
  productsSectionLabel: 'Catálogo de Produtos',
  productsSectionTitle: 'Produtos em Destaque do CSSBuy Spreadsheet',
  productsSectionDesc: 'Navegue pela nossa seleção de produtos. Clique em qualquer item para ver detalhes e comprar no kaspreadsheet.com.',
  buyNow: 'Comprar Agora',
  loadMore: 'Carregar Mais Produtos',
  showingCount: 'Mostrando {{visible}} de {{total}} produtos',
};

export default translation;